import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { hubUrl } from "../../utils/phoenix-utils";
import { InvitePopoverButton } from "./InvitePopover";
import { useInviteUrl } from "./useInviteUrl";

export function InvitePopoverContainer({ hub, hubChannel, dashboardChannel, scene, store, ...rest }) {
  const resolvedDashboardChannel = dashboardChannel || window.APP?.dashboardChannel;
  const [shareUrl, setShareUrl] = useState(null);
  const [shareUrlLoading, setShareUrlLoading] = useState(Boolean(resolvedDashboardChannel?.shareHub));

  let embedText = null;
  const embedToken = hub.embed_token || store.getEmbedTokenForHub(hub);
  if (embedToken) {
    const embedUrl = hubUrl(hub.hub_id, { embed_token: embedToken });
    embedText = `<iframe src="${embedUrl}" style="width: 1024px; height: 768px;" allow="microphone; camera; vr; speaker;"></iframe>`;
  }

  const popoverApiRef = useRef();

  const closePopOver = () => {
    popoverApiRef.current.closePopover();
  };

  // Handle clicking on the invite button while in VR.
  useEffect(() => {
    window.addEventListener("open-qr-modal", closePopOver);
  }, [scene, popoverApiRef]);

  useEffect(() => {
    let cancelled = false;

    setShareUrl(null);

    if (!resolvedDashboardChannel?.shareHub) {
      setShareUrlLoading(false);
      return () => {
        cancelled = true;
      };
    }

    setShareUrlLoading(true);
    resolvedDashboardChannel
      .shareHub(hub.hub_id)
      .then(url => {
        if (!cancelled) {
          setShareUrl(url || null);
          setShareUrlLoading(false);
        }
      })
      .catch(error => {
        console.error("Failed to generate room share shortlink", error);
        if (!cancelled) {
          setShareUrl(null);
          setShareUrlLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [resolvedDashboardChannel, hub.hub_id]);

  const inviteRequired = hub.entry_mode === "invite";
  const canGenerateInviteUrl = hubChannel.can("update_hub");

  const { fetchingInvite, inviteUrl, revokeInvite } = useInviteUrl(
    hubChannel,
    !inviteRequired || !canGenerateInviteUrl
  );

  if (inviteRequired && !canGenerateInviteUrl) {
    return null;
  }

  return (
    <InvitePopoverButton
      inviteRequired={inviteRequired}
      fetchingInvite={fetchingInvite}
      inviteUrl={inviteUrl}
      revokeInvite={revokeInvite}
      url={shareUrl}
      shareUrlLoading={shareUrlLoading}
      embed={embedText}
      popoverApiRef={popoverApiRef}
      {...rest}
    />
  );
}

InvitePopoverContainer.propTypes = {
  hub: PropTypes.object.isRequired,
  dashboardChannel: PropTypes.object,
  scene: PropTypes.object.isRequired,
  hubChannel: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
};
